import PendoColorPicker from '../../../components/color-picker/pendo-color-picker.vue.js';
import PendoButton from '../../../components/button/pendo-button.vue.js';

var script = {
  name: 'AppColorPicker',
  components: {
    PendoColorPicker,
    PendoButton
  },
  props: {
    initialColor: {
      type: String,
      default: ''
    },
    swatchColors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedColor: '#000'
    };
  },
  watch: {
    initialColor: {
      handler(newColor) {
        this.selectedColor = newColor || '#000';
      },
      immediate: true
    }
  },
  methods: {
    confirmColor() {
      this.$emit('favicon-color-changed', this.selectedColor !== '#000' ? this.selectedColor : null);
    },
    cancelColor() {
      this.$emit('cancel-color-change');
    }
  }
};

export { script as default };
//# sourceMappingURL=app-color-picker.vue2.js.map
